import { FC, useEffect, useState } from 'external/react';
import { columns } from '../ClientsTableProperties';
import useAdmin from 'context/admin-context/hook';
import { isUUID } from 'external/lodash';

type PurchaseInfoRowProps = {
  clientData: any;
};

const ClientsTablePurchaseInfoRow: FC<PurchaseInfoRowProps> = ({ clientData: item }) => {
  const { getStripeInfo } = useAdmin();
  const [stripeInfo, setStripeInfo] = useState([]);

  useEffect(() => {
    if (isUUID(item.id)) getStripeInfo(item.id).then(v => { setStripeInfo(v.data); });
  }, [item.id]);

  return (
    <tr>
      <td colSpan={columns.length} style={{ padding: '0 16px 12px 32px', background: '#f9f9f9' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.9em' }}>
          <thead>
            <tr style={{ borderBottom: '2px solid #ddd', color: '#555', fontWeight: 600 }}>
              <th style={{ padding: '6px 10px', textAlign: 'left' }}>Plan</th>
              <th style={{ padding: '6px 10px', textAlign: 'left' }}>Paquete</th>
              <th style={{ padding: '6px 10px', textAlign: 'left' }}>Fecha de compra</th>
              <th style={{ padding: '6px 10px', textAlign: 'left' }}>Precio</th>
            </tr>
          </thead>
          <tbody>
            {stripeInfo.map((purchase: any, index: any) => (
              <tr key={purchase.id ?? index} style={{ borderBottom: '1px solid #eee' }}>
                <td style={{ padding: '6px 10px' }}>{purchase.offerName}</td>
                <td style={{ padding: '6px 10px' }}>{purchase.planAlias}</td>
                <td style={{ padding: '6px 10px' }}>{new Date(purchase.purchaseDate).toLocaleDateString()}</td>
                <td style={{ padding: '6px 10px' }}>{purchase.price}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </td>
    </tr>
  );
};

export default ClientsTablePurchaseInfoRow;